import { Mention } from "@tiptap/extension-mention";
import type { Node } from "@tiptap/pm/model";
import { CustomValueInTemplate } from "../CustomValueInTemplate/CustomValueInTemplate";
import type { PasteTransformInternalConfig } from "./PasteTransform";

interface ParseVariablesIntoNodesProps {
  line: Node;
  config: PasteTransformInternalConfig;
}

export function parseVariablesIntoNodes({
  line,
  config: { allowedVariables, allowedCustomValues, currentCustomValues }
}: ParseVariablesIntoNodesProps) {
  const nodes: Array<Node> = [];

  if (
    !line.text ||
    (allowedVariables.length === 0 && allowedCustomValues.length === 0)
  ) {
    return [line];
  }

  const variablesOrCustomValuesRegex = new RegExp(
    "\\b" +
      allowedVariables.concat(allowedCustomValues).join("\\b|\\b") +
      "\\b",
    "g"
  );

  let pos = 0;
  let match = variablesOrCustomValuesRegex.exec(line.text);

  while (match) {
    const start = match.index;
    const end = start + match[0].length;

    // if anything comes before the match, add as regular text node
    if (start > 0) {
      nodes.push(line.cut(pos, start));
    }

    // extract the match & store relevant info
    const variableOrCustomValueName = line.text.slice(start, end);
    const nodeType = allowedVariables.includes(variableOrCustomValueName)
      ? Mention.name
      : CustomValueInTemplate.name;
    line.cut(start, end);

    // add matched element as dedicated node according to type
    nodes.push(
      line.type.schema.node(nodeType, {
        id: variableOrCustomValueName,
        label:
          nodeType === CustomValueInTemplate.name
            ? currentCustomValues[variableOrCustomValueName]
            : null
      })
    );

    // advance to end of match & check for another one
    pos = end;
    match = variablesOrCustomValuesRegex.exec(line.text);
  }

  // add any remaining text after the last match
  if (pos < line.text.length) {
    nodes.push(line.cut(pos));
  }

  return nodes;
}
